import React, { PureComponent } from "react";
import './index.css';
import { hideVolumesComponentForMultiBeds } from '../../../actions/multi-bed-actions';
import { connect } from 'react-redux';
import ProjectSelectors from '../../../reducers/project-reducer';

class ToggleVolumeIconComponent extends PureComponent {
  render() {
    const { isHidden } = this.props;

    return (
      <i
        onClick={() => this.toggleVolumes()}
        className={`ms-Icon ms-Icon--Chevron${isHidden ? 'Up' : 'Down'}Small ms-font-su toggleVolumeButton`}
        style={css.style}
        compoent-name="ToggleVolumeIconComponent"
      />
    );
  }

  toggleVolumes() {
    this.props.hideVolumesComponentForMultiBeds(!this.props.isHidden);
  }
}

const css = {
  style: {
    zIndex: 99,
    cursor: 'pointer',
    textAlign: 'center',
    position: 'absolute',
  },
};

const mapStateToProps = (state) => {
  return {
    isHidden: state.multiBed.hideVolumesComponent,
    isMultiBed: ProjectSelectors.isMultiBedProject(),
  };
};

const mapDispatchToProps = {
  hideVolumesComponentForMultiBeds,
};

export default connect(mapStateToProps, mapDispatchToProps)(ToggleVolumeIconComponent);



// WEBPACK FOOTER //
// ./src/components/LayoutSections/ToggleVolumeIcon/index.js